import React from 'react';
import { dispatch } from '@rematch/core';
import { connect } from 'react-redux';
import { Route } from "react-router-dom";
import {UsersTabs} from './Designer/UsersTabs';
import './styles.css'
class Users extends React.Component {

  componentDidMount() {
    dispatch.app.setCurrentContext("acc-user");

    let isDisabled = false;
    let account = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id === this.props.selectedAccount._id })[0];
    if (account.role === "user") {
      isDisabled = true;
    } else if (account.role === "customerAdmin" && !account.isActive) {
      isDisabled = true;
    }

    if (isDisabled) {
      this.props.history.push({
        pathname: `/app/${this.props.selectedAccount._id}/dashboard`
      });
    }
  }

  render() {
    return (
      <div>
        <Route exact path="/app/:accountId/users" render={() => (<UsersTabs  {...this.props} />)} />
        <Route exact path="/app/:accountId/users/:activeIndex" render={() => (<UsersTabs  {...this.props} />)} />
      </div>
    )
  }
}

function mapStateToProps(state) {

  return {
    selectedAccount: state.app.selectedAccount,
    accountInvitedUser: state.account.accountInvitedUser,
    InviteUserLoader: state.loading.effects.invite.sendInviteByAccountAsync,
    user: state.app.user,
    userCache: state.app.userCache,
    selectedOrganisation: state.app.selectedOrganisation,
    addedAccountUser: state.invite.addedAccountUser
  };
}

const connectedUsers = connect(mapStateToProps)(Users);
export { connectedUsers as Users }; 